import React from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";
import { NeoSideMenu, NeoBadge } from "../../../../components/Common";
import { INTEGRATION_PROVIDERS } from "../constants";

/**
 * IntegrationSidebar
 * Sidebar com as integrações disponíveis utilizando o NeoSideMenu do Neo Design System.
 */
const IntegrationSidebar = ({ integrations, activeProviderId, onSelect, loading, evolutionStatus }) => {
    const totalActive = INTEGRATION_PROVIDERS.filter(
        (p) => integrations[p.id]?.isActive
    ).length;

    return (
        <NeoSideMenu
            title="Integrações"
            subtitle={`${totalActive} de ${INTEGRATION_PROVIDERS.length} ativas`}
            icon="mdi-puzzle-outline"
            loading={loading}
        >
            <ListGroup flush>
                {INTEGRATION_PROVIDERS.map((provider) => {
                    const isActive = activeProviderId === provider.id;
                    const isConfigured = !!integrations[provider.id]?.isActive;

                    return (
                        <div className="px-2 mb-1.5" key={provider.id}>
                            <ListGroupItem
                                tag="button"
                                action
                                onClick={() => onSelect(provider.id)}
                                className={`border-0 py-3 px-3 d-flex align-items-center justify-content-between select-none neo-side-menu-item ${isActive ? "neo-side-menu-item--active" : ""}`}
                            >
                                <div className="d-flex align-items-center flex-grow-1 overflow-hidden">
                                    <div className="side-menu-icon-wrapper me-3 flex-shrink-0">
                                        <i 
                                            className={`mdi ${provider.icon} font-size-16`} 
                                            style={{ color: isActive ? "#ffffff" : provider.color }}
                                        />
                                    </div>
                                    <div className="text-start overflow-hidden">
                                        <h6 className="mb-0 fw-bold text-truncate font-size-13 side-menu-title">
                                            {provider.name}
                                        </h6>
                                        <span className="text-muted small font-size-11 d-block text-truncate">
                                            {provider.description}
                                        </span>
                                    </div>
                                </div>

                                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                    {provider.id === "evolution" && evolutionStatus && (
                                        <span
                                            title={evolutionStatus === "open" ? "Online" : evolutionStatus === "close" ? "Offline" : "Verificando..."}
                                            className={`rounded-circle d-inline-block`}
                                            style={{
                                                width: 8,
                                                height: 8,
                                                backgroundColor: evolutionStatus === "open" ? "#2e7d32" : evolutionStatus === "checking" ? "#784b22" : "#c62828",
                                                boxShadow: evolutionStatus === "open" ? "0 0 6px #2e7d32" : "none",
                                            }}
                                        />
                                    )}
                                    {isConfigured && (
                                        <NeoBadge color="success">
                                            Ativa
                                        </NeoBadge>
                                    )}
                                </div>
                            </ListGroupItem>
                        </div>
                    );
                })}
            </ListGroup>
        </NeoSideMenu>
    );
};

IntegrationSidebar.propTypes = {
    integrations: PropTypes.object.isRequired,
    activeProviderId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    evolutionStatus: PropTypes.string,
};

export default IntegrationSidebar;
